import type {
  JSXElementConstructor,
  ReactElement,
  ReactFragment,
  ReactPortal,
} from 'react';

import type { Dentist } from '../..';
import { ChevronRight } from '../../../icons/ChevronRight';
import { MapIcon } from '../../../icons/MapIcon';
import { PhoneIcon } from '../../../icons/PhoneIcon';
import styles from './docs.module.css';
import {
  useDentistStore,
  useSelectedDentistDataStore,
} from '../../../../stores/usePaginacao';
import DentistList from '../../../../components/DentistList/DentistList';

const DocList = ({ docList }: { docList: any[] }): ReactElement => {
  const setSelectedDentist = useSelectedDentistDataStore(
    x => x.setselectedDentistData,
  );
  const handleSelecionarDentista = (dentist: any) => {
    setSelectedDentist(dentist);
  };

  return (
    <ul className={styles.docList}>
      {docList.map(doc => (
        <li className={styles.item} key={doc.clinicaId}>
          <p className={styles.docInfo}>
            {doc.tipoEstabelecimento ? doc.tipoEstabelecimento : 'Clínica'}
          </p>
          <div className={styles.docData}>
            <div>
              {/*<h3 className={styles.docTitle}>{doc.razaoSocial}</h3>*/}
              <h3 className={styles.docTitle}>{doc.nomeFantasia}</h3>

              <div className="flex items-center gap-4 p-3">
                <MapIcon />
                <div className="text-sm text-medium-emphasis">
                  <p className="">
                    {doc.endereco} - {doc.uf} {doc.municipio}
                  </p>
                </div>
              </div>
              <div className="flex items-center gap-4 ml-3">
                <PhoneIcon />
                <p className="text-lg text-medium-emphasis">
                  {doc.telefone ? doc.telefone : ''}
                </p>
              </div>
              <div>
                <div className={styles.docData}>
                  <div>
                    <p className={styles.docInfo}>
                      {doc.tipoEstabelecimento
                        ? doc.tipoEstabelecimento
                        : 'Dentistas'}
                    </p>
                    {doc.dentistas.map(
                      (dent: {
                        nome:
                          | string
                          | number
                          | boolean
                          | ReactElement<
                              any,
                              string | JSXElementConstructor<any>
                            >
                          | ReactFragment
                          | ReactPortal;
                        especialidades:
                          | string
                          | number
                          | boolean
                          | ReactElement<
                              any,
                              string | JSXElementConstructor<any>
                            >
                          | ReactFragment
                          | ReactPortal;
                      }) => (
                        <>
                          <h3 className={styles.docTitle}>{dent.nome}</h3>
                          <div className="flex items-center gap-4 p-2">
                            <p className={styles.docInfo}>
                              {dent.especialidades}
                            </p>
                          </div>
                        </>
                      ),
                    )}
                  </div>
                </div>
              </div>
            </div>

            {/* <DentistList
              docList={docList}
              handleSelecionarDentista={handleSelecionarDentista}
            /> */}

            <button
              onClick={() => {
                setSelectedDentist(doc);
              }}
            >
              <ChevronRight />
            </button>
          </div>
        </li>
      ))}
    </ul>
  );
};

export default DocList;
